// @flow

import React from 'react';
import { connectHits } from 'react-instantsearch-dom';

import CardClub from 'containers/fragments/card/CardClubContainer';
import type { SearchClub } from 'types/Club';
import { sortClubs, getDisplayedClubs, hitToClubPreview } from 'utils/clubUtils';

type Props = {
    clubPerPage: number,
    currentPage: number,
    hits: SearchClub[],
    practices: string[],
    sort: string,
    userLatitude: number,
    userLongitude: number,
    maxDistance?: number,
};

function Clubs({ clubPerPage, currentPage, hits, practices, sort, userLatitude, userLongitude, maxDistance }: Props) {
    const sortedClubs = sortClubs(hits.map(hitToClubPreview), sort, userLatitude, userLongitude);
    const displayedClubs = getDisplayedClubs(sortedClubs, clubPerPage, currentPage);
    return (
        <>
            {displayedClubs.map((club, index) => (
                <CardClub
                    searchedPractices={practices}
                    key={club.id}
                    club={club}
                    position={index + 1 + (currentPage - 1) * clubPerPage}
                    distance={club._geoDistance ? (club._geoDistance / 1000) : 0}
                />
            )
            )}
        </>
    );
}

export default connectHits(Clubs);